"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVisible = void 0;
var react_1 = require("react");
// Checks if the element is in viewport,
// element: useRef
// rootMargin:
//  if 0px trigger when any part of the element comes to view
//  if negative (e.g. -100px) trigger when 100px of element in view etc.
var isVisible = function (element, rootMargin) {
    var _a = (0, react_1.useState)(false), isVisible = _a[0], setIsVisible = _a[1];
    (0, react_1.useEffect)(function () {
        var observer = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            setIsVisible(entry.isIntersecting);
        }, { rootMargin: rootMargin });
        element.current && observer.observe(element.current);
        return function () { return observer.unobserve(element.current); };
    }, []);
    return isVisible;
};
exports.isVisible = isVisible;
